import _ from 'lodash';

const checkIsNestedFormValue = value => _.isPlainObject(value) && !_.has(value, 'value');

export const reseedFormState = ({ currentForm, previousInitialValues, nextInitialValues }) => {
  if (
    checkIsNestedFormValue(currentForm) ||
    checkIsNestedFormValue(nextInitialValues) ||
    checkIsNestedFormValue(previousInitialValues)
  ) {
    const keys = _.union(
      _.keys(currentForm),
      _.keys(previousInitialValues),
      _.keys(nextInitialValues),
    );

    return keys.reduce((acc, key) => {
      const value = reseedFormState({
        currentForm: currentForm?.[key],
        previousInitialValues: previousInitialValues?.[key],
        nextInitialValues: nextInitialValues?.[key],
      });

      return _.isUndefined(value) ? acc : { ...acc, [key]: value };
    }, {});
  }

  const isUserEdited =
    !_.isUndefined(currentForm) && !_.isEqual(currentForm, previousInitialValues);

  return _.cloneDeep(isUserEdited ? currentForm : nextInitialValues);
};
